export default __webpack_public_path__ + "static/media/dots.f35aaf93.svg";